import React, { useState } from 'react'
import clsx from 'clsx'
import Image from 'next/image'
import ProductPlaceholderIcon from '@ancon/wildcat-ui/shared/static/placeholders/product-v2.svg'

import isDefaultProductCardStyle from '../utils/isDefaultProductCardStyle'
import OptimizedImage from '../../app/components/OptmizedImage'

import styles from './ProductCardBanner.module.scss'
import ProductImageLoadingSpinner from './ProductImageLoadingSpinner'

export type ProductCardBannerProps = {
  productName: string | null
  productImageId?: string | null
  disabled?: boolean
}

export default function ProductCardBanner({
  productName,
  productImageId,
  disabled = false,
}: ProductCardBannerProps) {
  const [isLoading, setIsLoading] = useState(!!productImageId)

  const defaultProductCardStyle = isDefaultProductCardStyle()

  return (
    <div
      className={clsx(styles.container, {
        [styles.imageOnTopStyle]: !defaultProductCardStyle,
        [styles.disabled]: disabled,
      })}
    >
      {(!defaultProductCardStyle || productImageId) && (
        <div className={styles.imageContainer}>
          {isLoading && <ProductImageLoadingSpinner />}
          {productImageId && (
            <OptimizedImage
              mediaId={productImageId}
              src={productImageId}
              className={styles.bannerImage}
              fill={!defaultProductCardStyle}
              alt={productName || 'product image'}
              width={defaultProductCardStyle ? 140 : undefined}
              height={defaultProductCardStyle ? 120 : undefined}
              onLoadStart={() => {
                setIsLoading(true)
              }}
              onLoad={() => setIsLoading(false)}
            />
          )}
          {!defaultProductCardStyle && !productImageId && (
            <Image
              alt={productName || 'product placeholder image'}
              className={styles.placeholderImage}
              src={ProductPlaceholderIcon}
            />
          )}
        </div>
      )}
    </div>
  )
}
